export default __webpack_public_path__ + "static/media/portada4.8394d999.jpg";